<template>
    <div class="dis-log">
        <el-table :data="tableData" style="width: 100%" border size="mini" :header-cell-style="{
            background: '#ecf4ff',
            color: '#333',
            fontWeight: '900',
            fontSize: '0.28rem'
        }">
            <el-table-column prop="" label="序号" width="" align="center">
                <template slot-scope="scope">
                    {{ scope.$index + 1 }}
                </template>
            </el-table-column>
            <el-table-column prop="assigned_task" label="任务编号" width="" align="center">
            </el-table-column>
            <el-table-column prop="" label="分配数量" width="" align="center">
                <template slot-scope="scope">
                    <el-tooltip effect="dark" content="点击查看详情" placement="top">
                        <el-link type="primary" @click="openDisDetail(scope.row.assigned_task)">
                            {{ scope.row.dis }}
                        </el-link>
                    </el-tooltip>
                </template>
            </el-table-column>
            <el-table-column prop="" label="分配人" width="" align="center">
                <template slot-scope="scope">
                    <div style="display: flex;flex-direction: column;">
                        <span>
                            {{ scope.row.assigneder }}
                        </span>
                        <el-tooltip effect="dark" content="分配时间" placement="top">
                            <span>
                                {{ scope.row.assigned_task_time }}
                            </span>
                        </el-tooltip>
                    </div>
                </template>
            </el-table-column>
            <!-- <el-table-column label="操作" fixed="right" width="100">
                <template slot-scope="scope">
                    <el-tooltip class="item" effect="dark" content="反馈" placement="top">
                        <el-button @click="openFeed(scope.row)" type="primary" size="mini" icon="el-icon-notebook-2"
                            circle>
                        </el-button>
                    </el-tooltip>
                </template>
            </el-table-column> -->
        </el-table>
        <div style="text-align: right;">
            <pagination-com :total="total" :perPage="pageSize" :npage="npage" @handleSizeChange="handleSizeChange"
                @handleCurrentChange="handleCurrentChange" />
        </div>
        <el-drawer :visible.sync="disDetailDrawer" append-to-body direction="rtl" :before-close="handleDisLogClose" size="50%">
            <template slot="title">
                <span style="color:#409eff;font-size:medium">分配详情</span>
            </template>
            <dis-detail :task="assigned_task"/>
        </el-drawer>
    </div>
</template>

<script>
import PaginationCom from '../../../commonReform/PaginationCom';
import DisDetail from './DisDetail';
export default {
    name: 'DisLog',
    props: {
        id: {
            required: true
        },
    },
    components: { PaginationCom, DisDetail },
    data() {
        return {
            hyperfHost:
                process.env.NODE_ENV === "development"
                    ? "http://127.0.0.1:9501/v1/"
                    : "https://qyh-next-server.zhang66.cn/v1/",
            tableData: [],
            pageSize: 10,
            total: 0,
            npage: 1,
            assigned_task: '',
            disDetailDrawer: false,
        }
    },
    methods: {
        loadTable() {
            this.$axios.get(`${this.hyperfHost}api/dis_log/list?page=${this.npage}`, {
                loadingClose: true,
                params: {
                    id: this.id,
                    perPage: this.pageSize
                }
            }).then(({ data }) => {
                if (data.code === 0) {
                    this.tableData = data.data.data
                    this.total = data.data.total
                }
            }).catch()
        },
        handleSizeChange(val) {
            this.npage = 1;
            this.pageSize = val;
            this.loadTable();
        },
        handleCurrentChange(val) {
            this.npage = val;
            this.loadTable();
        },
        openDisDetail(assigned_task) {
            this.assigned_task = assigned_task
            this.disDetailDrawer = true
        },
        handleDisLogClose(done) {
            this.assigned_task = ''
            done();
        },
    },
    watch: {
        id: {
            immediate: true,
            handler(n) {
                if (n) this.loadTable()
            }
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/pages/cloudClue/Components/DisLog.vue